var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"common_btn",style:({ width: _vm.changeWidth, backgroundColor: _vm.isActive ? '#210f03' : _vm.unActiveColor }),on:{"click":_vm.btnClickEvent}},[_vm._v(_vm._s(_vm.btnName))])}
var staticRenderFns = []

export { render, staticRenderFns }